export const FETCH_ERASURE_HISTORY_LIST_FETCH_INIT = 'PRODUCT|ERASURE_HISTORY_FETCH_INIT';
export const FETCH_ERASURE_HISTORY_LIST_START = 'PRODUCT|ERASURE_HISTORY_FETCH_START';
export const FETCH_ERASURE_HISTORY_LIST_SUCCESS = 'PRODUCT|ERASURE_HISTORY_FETCH_SUCCESS';
export const FETCH_ERASURE_HISTORY_LIST_FAIL = 'PRODUCT|ERASURE_HISTORY_FETCH_FAIL';

export const FETCH_PALETTE_HISTORY_LIST_FETCH_INIT = 'PRODUCT|PALETTE_HISTORY_FETCH_INIT';
export const FETCH_PALETTE_HISTORY_LIST_START = 'PRODUCT|PALETTE_HISTORY_FETCH_START';
export const FETCH_PALETTE_HISTORY_LIST_SUCCESS = 'PRODUCT|PALETTE_HISTORY_FETCH_SUCCESS';
export const FETCH_PALETTE_HISTORY_LIST_FAIL = 'PRODUCT|PALETTE_HISTORY_FETCH_FAIL';